<template>
  <div>

    <MainHeaderCompo />
    <router-view></router-view>



  </div>
</template>

<script>
import MainHeaderCompo from "@/components/MainHeaderCompo.vue";


export default {
  name: "App",
  components: {
    MainHeaderCompo

 
  },
};
</script>

<style>
.fa-chevron-right {
    padding: 0px 8px;
}

.banner {
    min-height: 56vh;
    padding-bottom: 20px;
    background: #546CB4;
    color: white;
    text-align: center;
    text-shadow: 1px 2px 3px rgb(0 0 0 / 50%);
}

.form-group {
    margin-bottom: 1rem;
}



</style>
